import {MyTab} from "./props";
import {ConfigProvider} from "antd";
import {StyledSegmented} from "./styles";
import classNames from "classnames";

const defaultConfig = {
  itemColor: '#68727D',
  trackBg: '#F4F5F7',
  itemSelectedBg: '#fff',
  itemSelectedColor: '#130F26',
  trackPadding: 4,
  controlPaddingHorizontal: 12,
  fontSize: 16,
  fontWeightStrong: 600,
  controlHeight: 48,
  borderRadius: 14,
}

const primaryConfig = {
  itemColor: '#4C4C4D',
  trackBg: '#fff',
  itemSelectedBg: '#FF9500',
  itemSelectedColor: '#fff',
  trackPadding: 10,
  fontSize: 18,
  controlPaddingHorizontal: 18,
  fontWeightStrong: 600,
  controlHeight: 64,
  borderRadius: 18,
}

const fireworkConfig = {
  itemColor: '#4C4C4D',
  trackBg: 'transparent',
  itemSelectedBg: 'rgba(231, 250, 255, 1)',
  itemSelectedColor: 'rgba(0, 141, 210, 1)',
  trackPadding: 8,
  fontSize: 14,
  controlPaddingHorizontal: 12,
  fontWeightStrong: 600,
  controlHeight: 55,
  borderRadius: 12,
}

export const MySegmented = (props: MyTab) => {
  const {type = 'default', ...otherProps} = props

  const config = type === 'firework' ? fireworkConfig 
               : type === 'primary' ? primaryConfig 
               : defaultConfig;

  return (
    <ConfigProvider theme={{
      components: {
        Segmented: config
      }
    }}>
      <StyledSegmented
        className={classNames(type)}
        {...otherProps}
      />
    </ConfigProvider>
  )
}